import { BrandLogo } from "@/components/BrandLogo";
import { SignupForm } from "@/modules/auth";

export default function SignupPage() {
  return (
    <main className="min-h-dvh bg-nb-bg py-10">
      <div className="flex justify-center">
        <BrandLogo />
      </div>
      <SignupForm />
    </main>
  );
}